<template lang="pug">
  .mb-1.d-flex.datepicker-container
    .mb-1
      b-input-group(:prepend="singleDatePicker ? $t('ui.date') : $t('ui.from')" size="sm")
        datepicker.form-control.datetimepicker(
          key="datefrom"
          v-model="dateRange.startDate"
          :format="format"
          :disabledDates="singleDatePicker ? allowed14DaysRange : disabledDates.start"
          @input="handleInput"
        )
    .mb-1(v-show="!singleDatePicker")
      b-input-group(:prepend="$t('ui.to')" size="sm")
        datepicker.form-control.datetimepicker(
          key="dateto"
          v-model="dateRange.endDate"
          :format="format"
          :disabledDates="disabledDates.end"
          @input="handleInput"
        )
    .mb-1(v-show="!singleDatePicker")
      b-input-group(size="sm")
        template(v-slot:prepend)
          b-input-group-text
            i.fas.fa-cogs
        b-form-select(
          ref="daterange"
          v-model="$store.state.layout.daterange"
          :options="options"
          size="sm"
          @change="setDateRange"
        )
</template>

<script>
export default {
  props: {
    singleDatePicker: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateRange: {
        startDate: this.singleDatePicker ? this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD") : this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    };
  },
  computed: {
    format() {
      return "yyyy-MM-dd";
    },
    allowed14DaysRange() {
      return {
        to: new Date(this.$moment(this.$moment().startOf('day').subtract(14, 'days').toDate()).format('YYYY-MM-DD')),
        from: new Date(this.$moment().format('YYYY-MM-DD'))
      };
    },
    disabledDates() {
      return {
        start: {
          to: new Date(this.$moment(this.$moment().startOf('month').subtract(5, 'months').toDate()).format('YYYY-MM-DD')),
          from: new Date(this.dateRange.endDate)
        },
        end: {
          to: new Date(this.dateRange.startDate)
        }
      };
    },
    options() {
      return {
        0: this.$t("ui.today"),
        1: this.$t("ui.yesterday"),
        2: this.$t("ui.this_week"),
        3: this.$t("ui.last_week"),
        4: this.$t("ui.this_month"),
        5: this.$t("ui.last_month")
      };
    }
  },
  mounted() {
    // this.setDateRange();
  },
  methods: {
    handleInput: function() {
      this.$store.dispatch("layout/setDateRange", this.dateRange);
      this.$emit("update", this.dateRange);
      this.$forceUpdate();
    },
    setDateRange: function() {
      var val = this.$store.getters.daterange;
      switch (val) {
        case "0":
          this.$set(
            this.dateRange,
            "startDate",
            this.$moment().subtract(12, "hours").format("YYYY-MM-DD")
          );
          this.$set(
            this.dateRange,
            "endDate",
            this.$moment().subtract(12, "hours").format("YYYY-MM-DD")
          );
          break;
        case "1":
          this.$set(
            this.dateRange,
            "startDate",
            this.$moment().subtract(36, "hours").format("YYYY-MM-DD")
          );
          this.$set(
            this.dateRange,
            "endDate",
            this.$moment().subtract(36, "hours").format("YYYY-MM-DD")
          );
          break;
        case "2":
          this.$set(
            this.dateRange,
            "startDate",
            this.$moment().startOf("isoWeek").format("YYYY-MM-DD")
          );
          this.$set(
            this.dateRange,
            "endDate",
            this.$moment().endOf("isoWeek").format("YYYY-MM-DD")
          );
          break;
        case "3":
          this.$set(
            this.dateRange,
            "startDate",
            this.$moment().subtract(1, "isoWeek").startOf("isoWeek").format("YYYY-MM-DD")
          );
          this.$set(
            this.dateRange,
            "endDate",
            this.$moment().subtract(1, "isoWeek").endOf("isoWeek").format("YYYY-MM-DD")
          );
          break;
        case "4":
          this.$set(
            this.dateRange,
            "startDate",
            this.$moment().startOf("month").format("YYYY-MM-DD")
          );
          this.$set(
            this.dateRange,
            "endDate",
            this.$moment().endOf("month").format("YYYY-MM-DD")
          );
          break;
        case "5":
          this.$set(
            this.dateRange,
            "startDate",
            this.$moment(
              this.$moment()
                .subtract(1, "month")
                .startOf("month")
            ).format("YYYY-MM-DD")
          );
          this.$set(
            this.dateRange,
            "endDate",
            this.$moment(
              this.$moment()
                .subtract(1, "month")
                .endOf("month")
            ).format("YYYY-MM-DD")
          );
      }
      this.handleInput();
    }
  }
};
</script>